"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnPinnedProperty = exports.resultsTableColumnPinnedPropertyDefinition = void 0;
exports.resultsTableColumnPinnedPropertyDefinition = {
    view: { label: 'Results Table Column Pinned' },
    constraints: [],
    type: 'boolean',
    multiple: false,
    default: false,
    name: 'results-table-column-pinned',
};
const isResultsTableColumnPinnedProperty = (prop) => {
    return prop.name === exports.resultsTableColumnPinnedPropertyDefinition.name;
};
exports.isResultsTableColumnPinnedProperty = isResultsTableColumnPinnedProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tcGlubmVkLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1jb2x1bW4tcGlubmVkLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMENBQTBDLEdBQUc7SUFDeEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLDZCQUE2QixFQUFFO0lBQzlDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLE9BQU8sRUFBRSxLQUFLO0lBQ2QsSUFBSSxFQUFFLDZCQUE2QjtDQUNKLENBQUE7QUFJMUIsTUFBTSxrQ0FBa0MsR0FBRyxDQUFDLElBQWtCLEVBQTRDLEVBQUU7SUFDakgsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtEQUEwQyxDQUFDLElBQUksQ0FBQTtBQUN0RSxDQUFDLENBQUE7QUFGWSxRQUFBLGtDQUFrQyxzQ0FFOUMifQ==